import React, { useState, useEffect } from "react";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { FaGripVertical } from "react-icons/fa6";
import { ListGroup, Offcanvas, Spinner } from "react-bootstrap";
import { eiwrsDepotManagementServices } from "../../../../APIServices/EIWRS/eiwrsDepotManagementServices";
import { useParams } from "react-router";

const ManageDepotOrder = ({ Show, Hide, Title, getStudyDepotRowData }) => {
  const [orderedRows, setOrderedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const { studyId } = useParams()

  const getStudyDepotList = async (e) => {
    setLoading(true);
    let data = await eiwrsDepotManagementServices.getStudyDepotRowData(
      "active",
      studyId,
    );
    setOrderedRows(data?.data || []);
    setLoading(false);
  };

  useEffect(() => {
    getStudyDepotList()
  }, []);

  const onDragEnd = async (result) => {
    if (!result.destination) return;
    const reordered = [...orderedRows];
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);
    setOrderedRows(reordered);
    const indexing = reordered?.map((item, index) => ({
      depotId: item.depotId,
      index: index,
    }));
    let userData = {
      studyId: studyId,
      indexing: indexing,
    };
    let resultIndex = await eiwrsDepotManagementServices.updateStudyDepotRowOrderData(
      userData
    );
    if (resultIndex?.statusCode === 200) {
      getStudyDepotRowData();
      getStudyDepotList()
    }
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: 520 }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-3">
        {loading ? (
          <div className="d-flex justify-content-center py-4">
            <Spinner animation="border" size="sm" />
          </div>
        ) : orderedRows?.length === 0 ? (
          <div className="text-muted">No depots found.</div>
        ) : (
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="manage-depot-order" type="ROW">
              {(provided) => (
                <ListGroup ref={provided.innerRef} {...provided.droppableProps} className="border-0">
                  {orderedRows.map((row, index) => (
                    <Draggable key={row?._id} draggableId={row?._id} index={index}>
                      {(draggableProvided, snapshot) => (
                        <ListGroup.Item
                          ref={draggableProvided.innerRef}
                          {...draggableProvided.draggableProps}
                          className={`d-flex justify-content-between align-items-start gap-2 py-2 ${snapshot.isDragging ? "shadow" : ""}`}
                        >
                          <div className="d-flex gap-2">
                            <div
                              {...draggableProvided.dragHandleProps}
                              className="text-muted mt-1"
                              style={{ cursor: "grab" }}
                            >
                              <FaGripVertical size={10} />
                            </div>
                            <div>
                              <small className="fw-semibold">{row?.row?.DEPOTNAME}</small>
                            </div>
                          </div>
                          <span className="text-muted small">#{index + 1}</span>
                        </ListGroup.Item>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </ListGroup>
              )}
            </Droppable>
          </DragDropContext>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ManageDepotOrder;